import FontAwesome from "../../../utilities/FontAwesome";
import styles from "./styles/dropdown.module.scss";
import classNames from 'classnames';
import NavigationLink from "../NavigationLink";

const dropdownIconClassName = classNames({
    [styles.dropdownIconLink]: true,
    ['nav-dropdown-item']: true,
});

export default function DropdownList(props) {
    const {url, title, description, icon, children} = props;

    if (props.header) {
        return <li>
            <h2 tabIndex={'-1'} className={'nav-dropdown-item'}>{props.header}</h2>
            <ul>
                {children
                    .filter(child => child.enabled)
                    .map((child) => {
                        return (
                            <li key={child.title + '-' + child.id}>
                                <NavigationLink navigationObj={child} tabIndex={'-1'} className={'nav-dropdown-item'} href={child.url}>
                                    {child.title}
                                </NavigationLink>
                            </li>
                        );
                    })}
            </ul>
        </li>
    } else {
        return <li role={'menuitem'}>
            <NavigationLink navigationObj={props} tabIndex={'-1'} href={url} className={dropdownIconClassName}>
                <div>
                    <FontAwesome ariaHidden={true} name={icon}/>
                </div>
                <div>
                    <h3>{title}</h3>
                    <span>{description}</span>
                </div>
            </NavigationLink>
        </li>
    }
}
